<head>
  <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
  <meta content="width=device-width, initial-scale=1.0" name="viewport"/>
  <meta content="" name="description"/>
  <meta content="" name="author"/>

  <link rel="shortcut icon" type="image/x-icon" href="https://9a812d2609e610ab07eb-b463fa4ca2c8095be4f297e4d7f6781b.ssl.cf2.rackcdn.com/favicon-timetap-16.png" sizes="16x16"/>
  <link rel="shortcut icon" type="image/x-icon" href="https://9a812d2609e610ab07eb-b463fa4ca2c8095be4f297e4d7f6781b.ssl.cf2.rackcdn.com/favicon-timetap-32.png" sizes="32x32"/>
  <link rel="shortcut icon" type="image/x-icon" href="https://9a812d2609e610ab07eb-b463fa4ca2c8095be4f297e4d7f6781b.ssl.cf2.rackcdn.com/favicon-timetap-96.png" sizes="96x96"/>
  <link rel="shortcut icon" type="image/x-icon" href="https://9a812d2609e610ab07eb-b463fa4ca2c8095be4f297e4d7f6781b.ssl.cf2.rackcdn.com/favicon-timetap-180.png" sizes="180x180"/>
  <meta name="MobileOptimized" content="320"/>
  <style>
    .hello-bar {
      background-color: #fdd947;
      text-align: center;
      color: #000;
      padding: 10px;
      font-family: "Open Sans", Arial, sans-serif;
    }

    .timetap-link {
      color: #000;
      border-bottom: 1px dotted #000;
    }
    .timetap-link:hover {
      color: #000;

    }
  </style>
</head>
<app-header *ngIf="isAuth()"></app-header>
<div *ngIf="!pageLoaded" class="appLoadingContainer">
  <i class="fa fa-spinner fa-spin fa-fw"></i> Loading Backoffice...
</div>
<router-outlet />
